import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home",
  id: "home"
}
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "hero-overlay" }
const _hoisted_4 = { class: "hero-content animate" }
const _hoisted_5 = { class: "hero-buttons" }
const _hoisted_6 = {
  href: "#contact",
  class: "appointment-button"
}
const _hoisted_7 = {
  href: "#pakete",
  class: "call-button"
}
const _hoisted_8 = { id: "about" }
const _hoisted_9 = { id: "pakete" }
const _hoisted_10 = { id: "review" }
const _hoisted_11 = { id: "references" }
const _hoisted_12 = { id: "contact" }

import {Calendar, Leaf} from "lucide-vue-next";
import "@/assets/styles/home.css";

import {onMounted} from "vue";

import AboutView from "@/views/AboutView.vue";
import ReferencesView from "@/views/ReferencesView.vue";
import ReviewView from "@/views/ReviewView.vue";
import ServiceView from "@/views/ServiceView.vue";
import ContactView from "@/views/ContactView.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";
import SidebarComponent from "@/components/SidebarComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

onMounted(() => {
  const elements = document.querySelectorAll(".animate");

  const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      {threshold: 0.2}
  );

  elements.forEach((el) => observer.observe(el));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hero-badge" }, " Gartenpflege • Pflasterarbeiten • Sichtschutz ", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h1", null, [
            _createTextVNode(" Garten- & Landschaftsbau"),
            _createElementVNode("br"),
            _createTextVNode(" mit Leidenschaft ")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, " Wir gestalten moderne Außenanlagen, pflegen Grünflächen und schaffen individuelle Wohlfühloasen rund um Ihr Zuhause. ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createVNode(_unref(Calendar)),
              _cache[0] || (_cache[0] = _createTextVNode(" Projekt anfragen ", -1))
            ]),
            _createElementVNode("a", _hoisted_7, [
              _createVNode(_unref(Leaf)),
              _cache[1] || (_cache[1] = _createTextVNode(" Leistungen ansehen ", -1))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(SidebarComponent),
    _createElementVNode("section", _hoisted_8, [
      _createVNode(AboutView)
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createVNode(ServiceView)
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createVNode(ReviewView)
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createVNode(ReferencesView)
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createVNode(ContactView)
    ]),
    _createVNode(FooterImpressum)
  ]))
}
}

})